export default function ArticleRenderer({ blocks }) {
  return (
    <div className="article-body max-w-3xl">
      {blocks.map((b, i) => {
        if (b.type === "h3") return <h3 key={i} className="font-display">{b.text}</h3>;
        if (b.type === "h4") return <h4 key={i}>{b.text}</h4>;
        if (b.type === "p") return <p key={i}>{b.text}</p>;
        if (b.type === "list")
          return (
            <ul key={i}>
              {b.items.map((it, j) => (
                <li key={j}>{it}</li>
              ))}
            </ul>
          );
        return null;
      })}
    </div>
  );
}
